import { render, staticRenderFns } from "./TransferList.vue?vue&type=template&id=197c536c&scoped=true&"
import script from "./TransferList.vue?vue&type=script&lang=js&"
export * from "./TransferList.vue?vue&type=script&lang=js&"
import style0 from "./TransferList.vue?vue&type=style&index=0&id=197c536c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c536c",
  null
  
)

export default component.exports